import CodeMirror from 'codemirror';


interface IHint {
    text: string;
    displayText: string;
}

interface IConfig {
    hints: IHint[];
    beingReplaced: number;
}

const Pos = CodeMirror.Pos;


function getTokenAt(editor: CodeMirror.Editor, curPos: CodeMirror.Position) {
    return editor.getTokenAt(curPos);
}

function scriptHint(
    editor: CodeMirror.Editor,
    getToken: (e: CodeMirror.Editor, cur: CodeMirror.Position) => CodeMirror.Token,
    { hints, beingReplaced }: IConfig) {
    const cur = (editor as any).getCursor();
    const token = getToken(editor, cur);

    const fromPos = token.start + 1 - beingReplaced;
    const toPos = token.end;

    return {
        list: hints,
        from: Pos(cur.line, fromPos),
        to: Pos(cur.line, toPos)
    };
}


export default function generateHint(config: IConfig) {
    return (editor: CodeMirror.Editor) => {
        return scriptHint(editor, getTokenAt, config);
    };
}
